<template lang="pug">
.line-it-button(
  :data-lang="lang"
  :data-url="url"
  :data-type="type"
  style="display: none;"
)
</template>

<script>
export default {
  name: "tweet-button",
  props: {
    url: {
      type: String,
      required: true
    },
    lang: {
      type: String,
      default: "ja"
    },
    type: {
      type: String,
      default: "share-a"
    }
  },
  mounted() {
    LineIt.loadButton();
  }
};
</script>
